import { useLocation } from "react-router-dom";
import SetPassword from "../containers/SetPassword";
import ForgotPassword from "../containers/ForgotPassword";
import Login from "../containers/Login";
import VerifyEmail from "../containers/VerifyEmail";

const useForm = () => {
  const location = useLocation();
  let Component;
  let title = '';
  
  switch (location.pathname) {
    case '/setPassword':
      Component = SetPassword;
      title = 'Set password';
      break;
    case '/forgotPassword': {
      Component = ForgotPassword;
      title = 'Forgot Password';
      break;
    }
    case '/verifyEmail': {
      Component = VerifyEmail;
      title = 'Verify Email';
      break;
    }
    default: // it means '/'
      Component = Login;
      title = 'Sign In';
  }
  
  return {Component, title}
};

export default useForm;